export const ErrorNotFound = () => {
  return (
    <div>
      <h1 className="text-xl">Error (404)</h1>
      <p><span id="404-error">We can't find the page you're looking for.</span></p>
    </div>
  );
};
